import React from "react";
import Contract from "./official/contract";
import Eligibility from "./official/eligibility";
import Payment from "./official/payment";

const Official = () => {
  return (
    <>
      <Contract />
      <Eligibility />
      <Payment />
    </>
  );
};

export default Official;
